module.exports = __webpack_public_path__ + "static/media/icon-permis.7ddfa3c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-permis.svg
// module id = 620
// module chunks = 0